import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ToastModule } from 'primeng/toast';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

import { AppRoutingModule } from './app-routing-module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { App } from './app';

// Override the Aura preset's primary palette to match the SmartPay brand blue
// (#2563eb — same value used in all component SCSS as $primary). This fixes the
// PrimeNG default green focus rings, active states, and button colours app-wide.
const SmartPayPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#3b82f6',
      600: '#2563eb',   // ← SmartPay primary
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#1e3a8a',
      950: '#172554',
    },
  },
});

@NgModule({
  declarations: [App, LoaderComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    LayoutModule,
    ToastModule,
  ],
  providers: [
    providePrimeNG({
      theme: {
        preset: SmartPayPreset,
        options: {
          darkModeSelector: '.app-dark',
        },
      },
    }),
  ],
  bootstrap: [App],
})
export class AppModule {}
